import { useCallback } from 'react';
import type { AutocompleteOption } from '../../../types';

interface useAutocompleteModalProps {
    setShowDropdown: (open: boolean) => void;
    resetSelection: () => void;
    setOptions: (opts: AutocompleteOption[]) => void;
    setNoResults: (value: boolean) => void;
}

export const useAutocompleteModal = ({ setShowDropdown, resetSelection, setOptions, setNoResults }: useAutocompleteModalProps) => {
    const handleModalOpenChange = useCallback(
        (open: boolean) => {
            setShowDropdown(open);

            if (!open) {
                resetSelection();
                setOptions([]);
                setNoResults(false);
            }
        },
        [setShowDropdown, resetSelection, setOptions, setNoResults],
    );

    return handleModalOpenChange;
};
